import { render, staticRenderFns } from "./Formulariosecciones.vue?vue&type=template&id=5bcfcff6"
import script from "./Formulariosecciones.vue?vue&type=script&lang=js"
export * from "./Formulariosecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports